
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{
  --half-height:0.86em;
}

.countdown-clock {
  display:flex;
  flex-wrap:wrap;
  justify-content:center;
  column-gap:3rem;
  row-gap:1rem;
  text-align:center;

  container-type:inline-size;
}

.heading {
  font-weight:var(--fw-semibold);
  color:var(----bh-neutral-darker);
  font-size:clamp(1em, 2vw + 0.5em, 1.5em);
}

.digit-group {
  position:relative;
  margin-top:0.5rem;
  display:flex;
  gap:0.5rem;
}

@media (min-width: 768px) {

  .digit-group {
    margin-top:1rem;
  }
}

.digit-group::after{
  content:':';
  position:absolute;
  top:50%;
  --tw-translate-y:-50%;
  transform:translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  font-weight:var(--fw-light);
  right:calc(-1.5rem - 0.5ch);
  margin-top:-6px;
  width:1ch;
  font-size:2.5em;
  color:var(----bh-neutral-darker);
}

.countdown-clock .container:last-child .digit-group::after {
  display:none;
}

@container (max-width: 730px){

.digit-group::after{
    display:none
}
  }

.card {
  position:relative;
  font-weight:var(--fw-light);

  padding-bottom:var(--half-height);

  font-size:clamp(1em, 9vw + 0.5em, 4em);
  line-height:0.95;
}

.card__top, .card__bottom, .card__back::before, .card__back::after {
  display:block;
  border-top-left-radius:0.5rem;
  border-top-right-radius:0.5rem;
  font-weight:var(--fw-light);
  height:var(--half-height);
  padding:0.35em 0;
  min-width:1.3em;

  color:var(--outline-white);

  background:var(--bh-brand-primary-default);
}

.card__bottom {
  position:absolute;
  top:50%;
  left:0px;
  overflow:hidden;
  background:var(--bh-brand-primary-default);
  border-radius:0 0 0.5rem 0.5rem;
}

.card__bottom::after {
  display:block;

  margin-top:calc(-1 * var(--half-height));
}

.card__back::before,
.card__bottom::after{
  content:attr(data-value);
}

.card__back {
  position:absolute;
  top:0px;
  left:0px;
  height:100%;
  perspective:none;
}

@media (prefers-reduced-motion: no-preference){

.card__back {
    perspective:280px;
    transform-style:preserve-3d;
    transform:translateZ(0);
  }
  }

.card__back::before {
  position:relative;
  z-index:-10;
  overflow:hidden;
}

.flip .card__back::before{
  animation:none;
}

@media (prefers-reduced-motion: no-preference){

.flip .card__back::before{
    animation:flipTop 0.3s linear;
    animation-fill-mode:both;
    transform-origin:center bottom
}
  }

.flip .card__back .card__bottom{
  animation:none;
}

@media (prefers-reduced-motion: no-preference){

.flip .card__back .card__bottom{
    transform-origin:center top;
    animation-fill-mode:both;
    animation:flipBottom 0.6s linear
}
  }

@keyframes flipTop{
  0%{
    transform:rotateX(0deg);
    z-index:2;
  }

  0%,
  99%{
    opacity:0.99;
  }

  100%{
    transform:rotateX(-90deg);
    opacity:0;
  }
}

@keyframes flipBottom{
  0%,
  50%{
    z-index:-1;
    transform:rotateX(90deg);
    opacity:0;
  }

  51%{
    opacity:0.99;
  }

  100%{
    opacity:0.99;
    transform:rotateX(0deg);
    z-index:5;
  }
}
`;